// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_ARTICLE_REVIEWED_BY = "Text po odborn\u00e9 str\u00e1nce zkontroloval(a):";
export const WIKI_ARTICLE_REVIEWED_BY_FEMALE = "Text po odborn\u00e9 str\u00e1nce zkontrolovala:";
export const WIKI_ARTICLE_REVIEWED_BY_MALE = "Text po odborn\u00e9 str\u00e1nce zkontroloval:";
